export const filterIt = (arr, searchKey, columns = [], scanDeep = []) => {
  // return arr.filter(obj => Object.keys(obj).some(key => obj[key].includes(searchKey)));
  const lowerCaseSearch = searchKey.toLowerCase();

  return arr.filter(obj =>
    Object.keys(obj).some(key => {
      if (typeof obj[key] === 'string') {
        if (columns.length === 0 || columns.includes(key)) {
          return obj[key].toLowerCase().includes(lowerCaseSearch);
        }
      } else if (scanDeep.includes(key)) {
        return Object.keys(obj[key]).some(subkey => {
          if (typeof obj[key][subkey] === 'string') {
            return obj[key][subkey].toLowerCase().includes(lowerCaseSearch);
          }

          return false;
        });
      }

      return false;
    }),
  );
};

export default filterIt;



// WEBPACK FOOTER //
// ./src/helpers/filterIt.js